export default __webpack_public_path__ + "static/media/bra-logo-depois.e269abf1.webp";